import { BUDGETOVAC_BASE_URL } from "@src/config/constants";
import { useCallback, useEffect, useState } from "react";

export const useUnsavedWorkMessage = () => {
  const [unsavedWorkMsg, setUnsavedWorkMsg] = useState<string | undefined>();

  const reset = () => setUnsavedWorkMsg(undefined);

  const handleUnsavedWork = useCallback(
    (e: MessageEvent<{ type: string; valid: boolean; message: string }>) => {
      let allowedOrigin: string | undefined;
      try {
        allowedOrigin = new URL(BUDGETOVAC_BASE_URL).origin;
      } catch {}

      if (
        !allowedOrigin ||
        allowedOrigin !== e.origin ||
        e.data.type !== "unsavedWork"
      )
        return;

      setUnsavedWorkMsg(e.data.valid ? e.data.message : undefined);
    },
    [setUnsavedWorkMsg],
  );

  useEffect(() => {
    window.addEventListener("message", handleUnsavedWork);
    return () => window.removeEventListener("message", handleUnsavedWork);
  }, [handleUnsavedWork]);

  return { message: unsavedWorkMsg, reset };
};
